import React, { useState } from 'react';
import { TrashIcon } from 'lucide-react';
export function ActionCard({
  action,
  index,
  onChange,
  onRemove
}) {
  const [actionTypes] = useState([{
    id: 'route',
    name: 'Route to Approver'
  }, {
    id: 'notify',
    name: 'Send Notification'
  }, {
    id: 'auto-approve',
    name: 'Auto-Approve'
  }, {
    id: 'escalate',
    name: 'Escalate'
  }, {
    id: 'trigger-workflow',
    name: 'Trigger Workflow'
  }]);
  const [targetTypes] = useState({
    route: [{
      id: 'user',
      name: 'User'
    }, {
      id: 'role',
      name: 'Role'
    }, {
      id: 'group',
      name: 'Group'
    }],
    notify: [{
      id: 'email',
      name: 'Email'
    }, {
      id: 'user',
      name: 'User'
    }, {
      id: 'role',
      name: 'Role'
    }, {
      id: 'group',
      name: 'Group'
    }],
    escalate: [{
      id: 'user',
      name: 'User'
    }, {
      id: 'role',
      name: 'Role'
    }]
  });
  // Sample data for targets
  const [targetOptions] = useState({
    user: [{
      id: 'user-001',
      name: 'John Smith'
    }, {
      id: 'user-002',
      name: 'Jane Doe'
    }, {
      id: 'user-003',
      name: 'Michael Johnson'
    }],
    role: [{
      id: 'role-001',
      name: 'Administrator'
    }, {
      id: 'role-002',
      name: 'Finance Manager'
    }, {
      id: 'role-003',
      name: 'Procurement Officer'
    }],
    group: [{
      id: 'group-001',
      name: 'Finance Team'
    }, {
      id: 'group-002',
      name: 'Procurement Team'
    }, {
      id: 'group-003',
      name: 'Executive Team'
    }],
    email: [{
      id: 'john.smith@example.com',
      name: 'john.smith@example.com'
    }, {
      id: 'jane.doe@example.com',
      name: 'jane.doe@example.com'
    }, {
      id: 'finance@example.com',
      name: 'finance@example.com'
    }]
  });
  // Sample data for templates
  const [notificationTemplates] = useState([{
    id: 'template-001',
    name: 'Invoice Approval Required'
  }, {
    id: 'template-002',
    name: 'High Value Invoice'
  }, {
    id: 'template-003',
    name: 'Compliance Review Required'
  }]);
  // Sample data for workflows
  const [workflows] = useState([{
    id: 'compliance-check',
    name: 'Compliance Check'
  }, {
    id: 'credit-check',
    name: 'Credit Check'
  }, {
    id: 'vendor-verification',
    name: 'Vendor Verification'
  }]);
  const handleTypeChange = e => {
    const newType = e.target.value;
    // Reset related fields when type changes
    if (newType === 'auto-approve') {
      onChange({
        type: newType,
        target: null,
        targetType: null,
        template: null
      });
    } else if (newType === 'trigger-workflow') {
      onChange({
        type: newType,
        target: null,
        targetType: null,
        workflowId: ''
      });
    } else {
      onChange({
        type: newType,
        target: '',
        targetType: targetTypes[newType]?.[0]?.id || '',
        template: newType === 'notify' ? '' : null
      });
    }
  };
  const handleTargetTypeChange = e => {
    onChange({
      targetType: e.target.value,
      target: '' // Reset target when target type changes
    });
  };
  const handleTargetChange = e => {
    onChange({
      target: e.target.value
    });
  };
  const handleTemplateChange = e => {
    onChange({
      template: e.target.value
    });
  };
  const handleWorkflowChange = e => {
    onChange({
      workflowId: e.target.value
    });
  };
  // Get background color based on action type
  const getCardColor = () => {
    switch (action.type) {
      case 'route':
        return 'bg-purple-50 border-purple-200';
      case 'notify':
        return 'bg-blue-50 border-blue-200';
      case 'auto-approve':
        return 'bg-green-50 border-green-200';
      case 'escalate':
        return 'bg-amber-50 border-amber-200';
      case 'trigger-workflow':
        return 'bg-indigo-50 border-indigo-200';
      default:
        return 'bg-gray-50 border-gray-200';
    }
  };
  return <div className={`p-4 border rounded-md ${getCardColor()}`} data-id="element-11192">
      <div className="flex justify-between items-start" data-id="element-11193">
        <div className="text-sm font-medium text-gray-900 mb-2" data-id="element-11194">
          Action {index + 1}
        </div>
        <button type="button" onClick={onRemove} className="inline-flex items-center p-1 border border-transparent rounded-full shadow-sm text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500" data-id="element-11195">
          <TrashIcon className="h-4 w-4" data-id="element-11196" />
        </button>
      </div>
      <div className="grid grid-cols-1 gap-y-3 gap-x-4 sm:grid-cols-4" data-id="element-11197">
        <div className="sm:col-span-4" data-id="element-11198">
          <label className="block text-xs font-medium text-gray-700 mb-1" data-id="element-11199">
            Action Type
          </label>
          <select value={action.type || ''} onChange={handleTypeChange} className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" data-id="element-11200">
            <option value="" data-id="element-11201">Select Action Type</option>
            {actionTypes.map(type => <option key={type.id} value={type.id} data-id="element-11202">
                {type.name}
              </option>)}
          </select>
        </div>
        {(action.type === 'route' || action.type === 'notify' || action.type === 'escalate') && <>
            <div className="sm:col-span-1" data-id="element-11203">
              <label className="block text-xs font-medium text-gray-700 mb-1" data-id="element-11204">
                Target Type
              </label>
              <select value={action.targetType || ''} onChange={handleTargetTypeChange} className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" data-id="element-11205">
                <option value="" data-id="element-11206">Select Type</option>
                {targetTypes[action.type]?.map(type => <option key={type.id} value={type.id} data-id="element-11207">
                    {type.name}
                  </option>)}
              </select>
            </div>
            <div className="sm:col-span-3" data-id="element-11208">
              <label className="block text-xs font-medium text-gray-700 mb-1" data-id="element-11209">
                Target
              </label>
              <select value={action.target || ''} onChange={handleTargetChange} disabled={!action.targetType} className={`shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md ${!action.targetType ? 'bg-gray-50' : ''}`} data-id="element-11210">
                <option value="" data-id="element-11211">Select Target</option>
                {targetOptions[action.targetType]?.map(target => <option key={target.id} value={target.id} data-id="element-11212">
                    {target.name}
                  </option>)}
              </select>
            </div>
          </>}
        {action.type === 'notify' && <div className="sm:col-span-4" data-id="element-11213">
            <label className="block text-xs font-medium text-gray-700 mb-1" data-id="element-11214">
              Notification Template
            </label>
            <select value={action.template || ''} onChange={handleTemplateChange} className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" data-id="element-11215">
              <option value="" data-id="element-11216">Select Template</option>
              {notificationTemplates.map(template => <option key={template.id} value={template.id} data-id="element-11217">
                  {template.name}
                </option>)}
            </select>
          </div>}
        {action.type === 'trigger-workflow' && <div className="sm:col-span-4" data-id="element-11218">
            <label className="block text-xs font-medium text-gray-700 mb-1" data-id="element-11219">
              Workflow
            </label>
            <select value={action.workflowId || ''} onChange={handleWorkflowChange} className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" data-id="element-11220">
              <option value="" data-id="element-11221">Select Workflow</option>
              {workflows.map(workflow => <option key={workflow.id} value={workflow.id} data-id="element-11222">
                  {workflow.name}
                </option>)}
            </select>
          </div>}
        {action.type === 'auto-approve' && <div className="sm:col-span-4" data-id="element-11223">
            <div className="p-2 bg-green-100 rounded-md text-sm text-green-800" data-id="element-11224">
              This action will automatically approve the document when
              conditions are met.
            </div>
          </div>}
      </div>
    </div>;
}